// Colours
import {
  terracotta,
  emeraldGreen,
  offWhite,
  white,
} from "../../Constants/ColourConstants";

export const styles = {
  background: {
    minHeight: "100%",
    backgroundColor: offWhite,
  },
  cardBackground: {
    backgroundColor: white,
    justifyContent: "center",
    alignItems: "center",
    p: "1rem",
    pb: "1.5rem",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "2rem",
  },
  cardTitle: {
    textAlign: "left",
    justifyContent: "flex-start",
    display: "flex",
    color: emeraldGreen,
    fontSize: 20,
    fontWeight: "medium",
  },
  inputTextField: {
    width: "90%",
    height: "50px",
    textAlign: "left",
    "@media (max-width: 600px)": {
      margin: "1rem auto",
    },
  },
  select: {
    width: "90%",
    height: "50px",
  },
  multiLineTextField: {
    width: "95%",
    minHeight: "50px",
  },
  buttonBox: {
    width: "100%",
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "medium",
  },
  datePicker: {
    width: "90%",
  },
  formWrapper: {
    px: { xs: "2rem", sm: "4rem" },
  },
  cardContentStack: {
    px: "1rem",
  },
  contactCheckboxLabel: {
    alignItems: { xs: "flex-start", sm: "center" },
    gap: 1,
    margin: 0,
    paddingTop: 0.5,
  },
  contactCheckbox: {
    color: emeraldGreen,
    padding: 0,
    "&.Mui-checked": {
      color: emeraldGreen,
    },
  },
  contactCheckboxText: {
    color: "black",
    textAlign: "left",
    fontSize: { xs: 14, sm: 16 },
  },
  contactCheckboxBold: {
    fontWeight: 700,
  },
  contactAlert: {
    marginTop: 0.5,
  },
  dialogTitle: {
    color: emeraldGreen,
    textTransform: "uppercase",
  },
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: white,
      borderRadius: "8px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
      width: "50%",
      minWidth: "315px",
      padding: 1,
    },
  },
  okButton: {
    borderRadius: "30px",
    padding: "8px 24px",
    backgroundColor: terracotta,
    color: white,
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)",
    minWidth: "120px",
  },
  loading: {
    marginTop: "5%",
    color: emeraldGreen,
  },
};
